import classNames from "classnames";
import React from "react";
import CtaButtonGroup, { CtaType } from "../molecules/CtaButtonGroup";

type PlansComparisonTableProps = {
  data: {
    type: string;
    header: string;
    footerHeading: string;
    footerSubheading: string;
    ctas: CtaType[];
    headerData: string[];
    bodyData: {
      plan: string;
      launch: string;
      rise: string;
      scale: string;
    }[];
    discountInfo: string;
  };
};

const PlansComparisonTable: React.FC<PlansComparisonTableProps> = ({
  data,
}) => {
  const {
    header,
    footerHeading,
    footerSubheading,
    ctas,
    headerData,
    bodyData,
  } = data;
  return (
    <div className="container">
      <p className="mb-12 text-center text-title40 font-semibold text-grey-4">{header}</p>
      <div className="w-full overflow-x-scroll !rounded-xl border border-purple-2">
        <table className="w-full min-w-[592px] table-fixed bg-white ">
          <thead>
            <tr>
              {headerData?.map((header, idx) => (
                <th
                  key={header}
                  className={classNames(
                    "border-b border-purple-1 p-6 text-title-20 font-semibold text-grey-4  ",
                    idx === 0 ? "border-r text-left" : "text-center",
                    idx === 1 && "bg-grey-1",
                    idx === 2 && "bg-grey-2"
                  )}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {bodyData?.map((row, idx) => (
              <tr key={row.launch}>
                <td className="border-r border-purple-1 px-6 py-3 text-title-14 font-semibold">
                  {row.plan}
                </td>
                <td className="bg-grey-1 px-6 py-3 text-center text-body-14 font-normal text-grey-4">
                  {row.launch}
                </td>
                <td className="bg-grey-2 px-6 py-3 text-center text-body-14 font-normal text-grey-4">
                  {row.rise}
                </td>
                <td className="px-6 py-3 text-center text-body-14 font-normal text-grey-4">
                  {row.scale}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex flex-col mt-12">
        <p className="text-title-20 font-semibold text-grey-4 text-center">{footerHeading}</p>
        <p className="text-body-16 font-normal text-grey-4 text-center mt-2 mb-6">{footerSubheading}</p>
        <CtaButtonGroup ctas={ctas} gap="gap-4" fullWidthOnMobile={false} />
        <div className="mt-2 flex items-center gap-2 mx-auto">
            <img
              src="/images/icons/percentage-pink.svg"
              alt="company logo"
              className="h-4 w-4"
            />
            <p className="text-body-12 font-normal text-grey-4">
              {data?.discountInfo}
            </p>
          </div>
      </div>
    </div>
  );
};
export default PlansComparisonTable;
